import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const emailSchedulerExceptionsState = (state: AppState) => state.emailScheduler.exceptions;

export const getEmailSchedulerExceptionsState = createSelector(
    emailSchedulerExceptionsState,
    ({ isProcessing, isSubmitted, hasError, isDeleting }) => ({ isProcessing, isSubmitted, hasError, isDeleting })
);

export const getExceptionEditProperties = createSelector(emailSchedulerExceptionsState, ({ properties }) => properties);
